import script from "./DeleteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteButton.vue?vue&type=script&setup=true&lang=js"

import "./DeleteButton.vue?vue&type=style&index=0&id=1a53e1ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a53e1ff"]])

export default __exports__